import React, { Component } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import PortalAuth from './features/PortalAuth';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render () {
        return <div>
            <BrowserRouter>
                <Switch>
                    <PortalAuth location={window.location}></PortalAuth>
                </Switch>
            </BrowserRouter>
        </div>
    }
}

export default App;
